import { Container, LoadingImage } from './LoadingIndicator.styled';

export function LoadingIndicator() {
  return (
    <Container>
      <LoadingImage />
    </Container>
  );
}
